<template>
  <div>
    <section class="xlrclh">
      <img class="top-img" src="../../assets/imgs/wuhou/6/base.png" alt="" />
      <div class="technological-process">
        <div class="rhtj mar-t2">
          <img class="top" src="../../assets/imgs/125/desc-title.png" alt="" />
          <div class="content">
            为打造一支师德高尚、业务精湛、结构合理、充满活力的高素质专业化创新型教师队伍，为武侯教育高质量发展提供坚实的人才和智力支撑，结合武侯教育实际，制定本细则。
          </div>
        </div>
        <div class="zccl">
          <img class="top" src="../../assets/imgs/wuhou/5/title1.png" alt="" />
          <div class="content" style="background-color: #fff">
            <div style="margin-bottom: 0.2rem">
              具备以下荣誉称号，并具有副高级及以上职称、全日制本科及以上学历的事业单位在编人员，原则上男45周岁以下，女40周岁以下，可作为优秀人才引进。特别优秀的可适当放宽年龄限制。
            </div>
            <div>
              （1）国家级优秀人才。获得全国优秀教师、优秀教育工作者、教书育人楷模等荣誉称号的人才。
            </div>
            <div>
              （2）省级优秀人才。获得省级特级教师、中小学名师、优秀教师、优秀班主任等荣誉称号的人才。
            </div>
            <div>
              （3）省会城市和副省级城市优秀人才。获得省会城市或副省级城市特级教师、学科带头人等荣誉称号的人才。
            </div>
          </div>
        </div>
        <div class="zccl">
          <img class="top" src="../../assets/imgs/wuhou/5/title2.png" alt="" />
          <div class="content" style="background-color: #d4e0ff">
            <div class="des" style="margin-top: 0.1rem">
              <div>
                （一）对具备全国优秀教师、优秀教育工作者、教书育人楷模和省级特级教师、中小学名师荣誉称号的引进人才，发放专项资助金30万元，分三年发放，其中首年发放15万元，其余两年按年度考核发放，考核合格后按剩余经费的50%发放。
              </div>
            </div>
            <div class="des" style="margin-top: 0.2rem">
              <div>
                （二）对具备省优秀教师、优秀班主任和省会城市或副省级城市特级教师荣誉称号的引进人才，发放专项资助金20万元，分三年发放，其中首年发放10万元，其余两年按年度考核发放，考核合格后按剩余经费的50%发放。
              </div>
            </div>
            <div class="des" style="margin-top: 0.2rem">
              <div>
                （三）对具备省会城市或副省级城市学科带头人荣誉称号的引进人才，发放专项资助金10万元，分三年发放，其中首年发放5万元，其余两年按年度考核发放，考核合格后按剩余经费的50%发放。
              </div>
            </div>
            <div class="des" style="margin-top: 0.2rem">
              <div>
                （四）新引进人才符合人才安居条件的人员，可租购由政府提供的人才公寓。（具体按《成都市人才公寓租售管理办法》实施）。
              </div>
            </div>
          </div>
        </div>
        <div class="part-two">
          <img
            src="../../assets/imgs/wuhou/5/title3.png"
            class="part-two-title-img"
          />
          <div
            style="
              margin-top: 1.44rem;
              font-size: 0.3rem;
              font-weight: 500;
              color: #333333;
              line-height: 0.44rem;
              text-align: left;
            "
          ></div>
          <div class="part-two-content" style="margin-top: 0.23rem">
            <div style="margin-bottom: 0.22rem; position: relative">
              <div class="part-two-dot">1</div>
              符合引进条件的优秀教育人才，由用人单位试用并初步考核后，向区教育局提交引进申请。
            </div>
            <div style="margin-bottom: 0.22rem; position: relative">
              <div class="part-two-dot">2</div>
              区教育局组织行业专家对拟引进人才的德能勤绩进行综合考评、研究。
            </div>
            <div style="margin-bottom: 0.22rem; position: relative">
              <div class="part-two-dot">3</div>
              区教育局党组将拟引进人才情况，报请上级部门审议，确定引进名单。
            </div>
            <div style="margin-bottom: 0.22rem; position: relative">
              <div class="part-two-dot">4</div>
              区教育局会同区级相关部门按程序办理手续，做好引进人才专项资助金的考核发放。
            </div>
          </div>
        </div>
        <div class="contact" style="margin-top: 0.3rem">
          <img class="top" src="../../assets/imgs/wuhou/1/title4.png" alt="" />
          <div class="content">
            <div class="number">
              <span class="label">政策咨询电话：</span>
              <div>
                <a href="tel:028-85067001">028-85067001</a>
              </div>
            </div>
            <div class="unit">
              <span class="label">责任单位：</span>
              武侯区教育局
            </div>
          </div>
        </div>
        <!-- <div class="codes">
          <img class="info" src="../../assets/imgs/147/code.png" />
        </div> -->
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";
.circle {
  width: 0.25rem;
  height: 0.25rem;
  border-radius: 50%;
  border: 0.06rem solid #ff6d60;
  margin-right: 0.08rem;
}
.commonCircle {
  display: flex;
  align-items: center;
  margin: 0.19rem 0;
  &-circle {
    width: 0.2rem;
    height: 0.2rem;
    border-radius: 50%;
    border: 0.06rem solid #ff6d60;
    flex-shrink: 0;
  }
  &-font {
    font-size: 0.34rem;
    color: #333;
    font-weight: 600;
  }
}
.part-two {
  margin-left: 0.02rem;
  width: 6.85rem;
  margin-top: 0.22rem;
  background: #e8eeff;
  border-radius: 0.16rem;
  padding-left: 0.25rem;
  padding-right: 0.3rem;
  box-sizing: border-box;
  margin: 0 auto;
  margin-top: 0.22rem;
  border: 0.00001px solid transparent;
  position: relative;
  .part-two-title-img {
    width: 7.03rem;
    height: 1.37rem;
    top: 0;
    left: -0.2rem;
    position: absolute;
  }

  .part-two-title {
    text-align: left;
    margin-left: 0.33rem;
    margin-bottom: 0.22rem;

    &::before {
      position: absolute;
      content: "";
      width: 0.28rem;
      height: 0.28rem;
      border-radius: 50%;
      background: none;
      border: 0.06rem solid #ff6d60;
      box-sizing: border-box;
      top: 0.08rem;
      left: -0.35rem;
    }
  }

  .part-two-items {
    width: 6.35rem;
    padding-bottom: 0.35rem;
    background: #ffffff;
    border-radius: 10px;
    padding: 0.31rem;
    box-sizing: border-box;
    position: relative;
    margin-bottom: 0.22rem;
  }
  .part-two-content {
    margin-top: 0.2rem;
    margin-bottom: 0.3rem;
    width: 6.22rem;
    background: #ffffff;
    border-radius: 10px;
    box-sizing: border-box;
    padding: 0.34rem 0.24rem 0.15rem 0.67rem;
    font-size: 0.26rem;
    // //font-family:: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #4e4e4e;
    line-height: 0.44rem;
    text-align: left;

    .part-two-dot {
      position: absolute;
      top: 0;
      left: -0.46rem;
      width: 0.36rem;
      height: 0.36rem;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 0.21rem;
      background: #739bfe;
      border-radius: 50%;
    }
  }
}
.part-four {
  width: 6.85rem;
  background: #e8eeff;
  border-radius: 10px;
  margin-left: 0.02rem;
  margin-top: 0.22rem;
  box-sizing: border-box;
  margin: 0 auto;
  margin-top: 0.22rem;
  border: 0.00001px solid transparent;
  position: relative;
  padding: 1.2rem 0.25rem 0 0.25rem;
  .part-two-title-img {
    width: 7.03rem;
    height: 1.37rem;
    top: 0;
    left: -0.2rem;
    position: absolute;
  }
  .main-content {
    margin-top: 0.34rem;
    width: 6.35rem;
    background: #ffffff;
    border-radius: 10px;
    box-sizing: border-box;
    padding-top: 0.9rem;
    padding-left: 0.35rem;
    padding-right: 0.31rem;

    .part-four-items {
      box-sizing: border-box;
      border-left: 0.02rem dashed #739bfe;
      margin-bottom: 0.6rem;
      padding-left: 0.33rem;
      padding-top: 0.2rem;
      position: relative;
      font-size: 0.26rem;
      // //font-family:: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #4e4e4e;
      line-height: 0.44rem;
      text-align: left;
      padding-bottom: 0.35rem;

      .title-bg {
        position: absolute;
        width: 3.31rem;
        height: 0.55rem;
        top: -0.6rem;
        left: -0.25rem;
        line-height: 0.55rem;
        font-size: 0.34rem;
        font-weight: bold;
        color: #3d5aa3;
        padding-left: 0.58rem;
        background: url(../../assets/imgs/144/p1.png) 0 0/100% 100%;
        border: 1px solid #fff;
      }

      .title-bg2 {
        background: url(../../assets/imgs/144/p2.png) 0 0/100% 100%;
      }

      .extendFont {
        min-width: 7rem;
        position: absolute;
        top: 50%;
        left: 0.58rem;
        transform: translateY(-50%);
      }

      .title-bg3 {
        background: url(../../assets/imgs/144/p3.png) 0 0/100% 100%;
      }

      .title-bg4 {
        background: url(../../assets/imgs/144/p4.png) 0 0/100% 100%;
      }

      .title-bg5 {
        background: url(../../assets/imgs/144/p5.png) 0 0/100% 100%;
      }

      .title-bg6 {
        background: url(../../assets/imgs/144/p6.png) 0 0/100% 100%;
      }

      .inside-title {
        font-weight: 800;
      }

      .part-four-content2 {
        font-weight: bolder;
      }
    }
  }
}
.xlrclh {
  background-color: $base-back;
  padding-top: 0.3rem;
  overflow: hidden;
  .top-img {
    width: 7.26rem;
    // height: 4.73rem;
  }

  .technological-process {
    transform: translateY(-2rem);

    .rhtj {
      position: relative;

      .top {
        width: 6.86rem;
        height: 2.12rem;
      }

      .content {
        width: 6.85rem;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        background: #ffffff;
        font-size: 0.26rem;
        color: #4e4e4e;
        text-align: left;
        position: relative;
        font-weight: 500;
        line-height: 0.44rem;
      }
    }

    .zccl {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
        line-height: 0.44rem;

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.35rem 0.23rem 0.3rem;
          position: relative;
          text-align: left;
          margin-top: 0.8rem;
          .title {
            position: absolute;
            top: -0.5rem;
            left: 50%;
            transform: translateX(-50%);
            min-width: 3.74rem;
            height: 0.67rem;
            line-height: 0.67rem;
            display: flex;
            justify-content: center;
            align-content: center;
            font-size: 0.32rem;
            font-weight: bold;
            color: #ffffff;
            border-radius: 1rem;
            background-color: #739bfe;
          }
        }
      }
    }

    .gmlc {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.86rem;
        background: #e8eeff;
        margin: -0.55rem auto;
        padding: 0 0.33rem 0.35rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;

        .circle-box {
          font-size: 0.34rem;
          color: #333;
          font-weight: bold;
          padding-top: 0.5rem;
          text-align: left;
          position: relative;
          .circle {
            width: 0.28rem;
            height: 0.28rem;
            border: 0.06rem solid #ff6d60;
            border-radius: 50%;
            flex-shrink: 0;
            box-sizing: border-box;
            position: absolute;
            left: 0;
            top: 0.62rem;
            display: inline-block;
          }
          .circle-txt {
            text-indent: 1.1em;
          }
        }

        .title {
          font-size: 0.36rem;
          font-weight: bold;
          color: #333333;
          text-align: left;
          line-height: 0.5rem;
        }

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.3rem 0.23rem;
          font-size: 0.26rem;
          font-weight: 500;
          color: #4e4e4e;
          line-height: 0.44rem;

          .line-item {
            font-size: 0.26rem;
            position: relative;
            z-index: 3;

            .line {
              position: absolute;
              width: 0.02rem;
              height: 130%;
              border-left: 0.02rem dashed #739bfe;
              left: 0.2rem;
              z-index: 0;
              //   background-color: #739bfe;
            }

            .line-title {
              font-size: 0.3rem;
              font-weight: bold;
              color: #3d5aa3;
            }

            .line-top {
              display: flex;
              width: 4.4rem;
              height: 0.55rem;
              background-image: url(../../assets/imgs/25/label.png);
              background-size: 100% 100%;
              z-index: 99;
              display: flex;
              align-items: center;
              box-sizing: border-box;
              padding-left: 0.1rem;

              .line-num {
                width: 0.44rem;
                height: 0.44rem;
                background: #fff;
                color: #3d5aa3;
                display: inline-flex;
                border-radius: 50%;
                justify-content: center;
                align-items: center;
                margin-right: 0.18rem;
                position: relative;
                z-index: 3;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 0.28rem;
                font-weight: bold;
              }
            }

            .line-content {
              //   border-left: 0.02rem dashed #739bfe;
              padding-bottom: 0.32rem;
              margin-left: 0.2rem;
              padding-left: 0.32rem;
              padding-top: 0.15rem;
              word-break: break-all;
              line-height: 0.44rem;
            }
          }
        }
      }
    }

    .codes {
      margin: 0 auto;
      margin-top: 0.25rem;
      width: 6.85rem;
      background: #fff;
      padding: 0.3rem;
      box-sizing: border-box;
      border-radius: 0.26rem;
      padding-top: 0.28rem;
      font-size: 0.26rem;
      font-weight: 500;
      color: #4e4e4e;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .info {
        width: 6.42rem;
        height: 1.94rem;
      }
    }
  }
}
</style>
